import Tooth11 from '@/components/Teeth/Front/11'
import Tooth12 from '@/components/Teeth/Front/12'
import Tooth13 from '@/components/Teeth/Front/13'
import Tooth14 from '@/components/Teeth/Front/14'
import Tooth15 from '@/components/Teeth/Front/15'
import Tooth16 from '@/components/Teeth/Front/16'
import Tooth17 from '@/components/Teeth/Front/17'
import Tooth18 from '@/components/Teeth/Front/18'
import Tooth21 from '@/components/Teeth/Front/21'
import Tooth22 from '@/components/Teeth/Front/22'
import Tooth23 from '@/components/Teeth/Front/23'
import Tooth24 from '@/components/Teeth/Front/24'
import Tooth25 from '@/components/Teeth/Front/25'
import Tooth26 from '@/components/Teeth/Front/26'
import Tooth27 from '@/components/Teeth/Front/27'
import Tooth28 from '@/components/Teeth/Front/28'
import Tooth31 from '@/components/Teeth/Front/31'
import Tooth32 from '@/components/Teeth/Front/32'
import Tooth33 from '@/components/Teeth/Front/33'
import Tooth34 from '@/components/Teeth/Front/34'
import Tooth35 from '@/components/Teeth/Front/35'
import Tooth36 from '@/components/Teeth/Front/36'
import Tooth37 from '@/components/Teeth/Front/37'
import Tooth38 from '@/components/Teeth/Front/38'
import Tooth41 from '@/components/Teeth/Front/41'
import Tooth42 from '@/components/Teeth/Front/42'
import Tooth43 from '@/components/Teeth/Front/43'
import Tooth44 from '@/components/Teeth/Front/44'
import Tooth45 from '@/components/Teeth/Front/45'
import Tooth46 from '@/components/Teeth/Front/46'
import Tooth47 from '@/components/Teeth/Front/47'
import Tooth48 from '@/components/Teeth/Front/48'

import Implant48 from '@/components/Teeth/Implant/48'
import Implant47 from '@/components/Teeth/Implant/47'
import Implant46 from '@/components/Teeth/Implant/46'
import Implant45 from '@/components/Teeth/Implant/45'
import Implant44 from '@/components/Teeth/Implant/44'
import Implant43 from '@/components/Teeth/Implant/43'
import Implant42 from '@/components/Teeth/Implant/42'
import Implant41 from '@/components/Teeth/Implant/41'


import Implant38 from '@/components/Teeth/Implant/38'
import Implant37 from '@/components/Teeth/Implant/37'
import Implant36 from '@/components/Teeth/Implant/36'
import Implant35 from '@/components/Teeth/Implant/35'
import Implant34 from '@/components/Teeth/Implant/34'
import Implant33 from '@/components/Teeth/Implant/33'
import Implant32 from '@/components/Teeth/Implant/32'
import Implant31 from '@/components/Teeth/Implant/31'

import Implant11 from '@/components/Teeth/Implant/11'
import Implant12 from '@/components/Teeth/Implant/12'
import Implant13 from '@/components/Teeth/Implant/13'
import Implant14 from '@/components/Teeth/Implant/14'
import Implant15 from '@/components/Teeth/Implant/15'
import Implant16 from '@/components/Teeth/Implant/16'
import Implant17 from '@/components/Teeth/Implant/17'
import Implant18 from '@/components/Teeth/Implant/18'


import Implant21 from '@/components/Teeth/Implant/21'
import Implant22 from '@/components/Teeth/Implant/22'
import Implant23 from '@/components/Teeth/Implant/23'
import Implant24 from '@/components/Teeth/Implant/24'
import Implant25 from '@/components/Teeth/Implant/25'
import Implant26 from '@/components/Teeth/Implant/26'
import Implant27 from '@/components/Teeth/Implant/27'
import Implant28 from '@/components/Teeth/Implant/28'

export const teethComponents = {
    components: {
        Tooth18,
        Tooth17,
        Tooth16,
        Tooth15,
        Tooth14,
        Tooth13,
        Tooth12,
        Tooth11,
        Tooth28,
        Tooth27,
        Tooth26,
        Tooth25,
        Tooth24,
        Tooth23,
        Tooth22,
        Tooth21,
        Tooth38,
        Tooth37,
        Tooth36,
        Tooth35,
        Tooth34,
        Tooth33,
        Tooth32,
        Tooth31,

        Tooth41,
        Tooth48,
        Tooth47,
        Tooth46,
        Tooth45,
        Tooth44,
        Tooth43,
        Tooth42
    }
}

export const implantTeethComponents = {
    components: {
        Implant48,
        Implant47,
        Implant46,
        Implant45,
        Implant44,
        Implant43,
        Implant42,
        Implant41,

        Implant38,
        Implant37,
        Implant36,
        Implant35,
        Implant34,
        Implant33,
        Implant32,
        Implant31,

        Implant11,
        Implant12,
        Implant13,
        Implant14,
        Implant15,
        Implant16,
        Implant17,
        Implant18,

        Implant21,
        Implant22,
        Implant23,
        Implant24,
        Implant25,
        Implant26,
        Implant27,
        Implant28,
    }
}


